import { z } from 'zod'

export const SUPPORT_MCP_ROOT_CONTRACT_VERSION = '1.0.0' as const

export const supportMcpRootResponseSchema = z.object({
  name: z.string(),
  version: z.string(),
  description: z.string(),
  endpoints: z.record(z.string()),
  auth: z.object({
    bootstrap: z.array(z.string()),
    session_contract: z.string(),
  }),
}).passthrough()

export type SupportMcpRootResponse = z.infer<typeof supportMcpRootResponseSchema>
